import React from 'react';
import { Helmet } from '@plone/volto/helpers';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { useSiteConfig } from '../../helpers/useSiteConfig';

/**
 * Injects the active site's brand palette as CSS custom properties on :root,
 * SSR-safe via Helmet. One frontend instance always serves one archive
 * (seamless build, one backend), so a single :root block is unambiguous. All
 * shared components read `var(--brand-*)`, which is how three sites keep their
 * distinct colours out of one build.
 */
const SiteTheme = () => {
  const site = useSiteConfig();
  const c = site.colors;
  const css = `:root{--brand-primary:${c.primary};--brand-secondary:${c.secondary};--brand-accent:${c.accent || c.primary};}`;
  return (
    <>
      <BodyClass className="prc-kit" />
    <Helmet>
      <html lang="en" data-site={site.id} />
      <style type="text/css">{css}</style>
    </Helmet>
    </>
  );
};

export default SiteTheme;
